import { AI_ASSISTANT_PENDO_EVENTS, trackAssistantEvent } from "./assistantAnalytics";

/**
 * Sends a suggested question as though the user had typed it.
 *
 * MessageInput owns sending and listens for this event, so a suggestion from
 * anywhere in the panel goes through the same path — including its refusal to
 * send while Lou is still answering.
 */
export const sendSuggestion = (text) => {
  if (!text) return;
  trackAssistantEvent(AI_ASSISTANT_PENDO_EVENTS.FOLLOWUP_CLICKED);
  window.dispatchEvent(
    new CustomEvent("ai-assistant-send-suggestion", { detail: { text } }),
  );
};

export default sendSuggestion;
